import { Injectable } from '@angular/core';

export enum FeatureFlags {
  PREVIEW = 'preview'
}

interface FeatureFlagState {
  [FeatureFlags.PREVIEW]: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private featureFlagState: FeatureFlagState = {
    [FeatureFlags.PREVIEW]: false
  };

  constructor() {
    this.loadFeatureFlags();
  }
  
  private loadFeatureFlags(): void {
    const storedState = localStorage.getItem('featureFlags');
    if (storedState) {
      try {
        const parsed = JSON.parse(storedState);
        // Migration depuis l'ancien format
        if (Array.isArray(parsed)) {
          this.migrateFromOldFormat(parsed);
        } else {
          this.featureFlagState = { ...this.featureFlagState, ...parsed };
        }
      } catch {
        this.featureFlagState = { [FeatureFlags.PREVIEW]: false };
      }
    }
  }

  private migrateFromOldFormat(oldFlags: string[]): void {
    // Migration: si des features étaient activées, on active le mode preview
    const hasFeatures = oldFlags.some(flag => 
      flag === 'Voir tous les bons des sites permis' || 
      flag === 'Importer des lignes de bons via le csv'
    );
    
    this.featureFlagState[FeatureFlags.PREVIEW] = hasFeatures;
    this.saveFeatureFlags();
  }
  
  getFeatureFlags(): FeatureFlags[] {
    return Object.keys(this.featureFlagState) as FeatureFlags[];
  }

  isPreviewEnabled(): boolean {
    return this.featureFlagState[FeatureFlags.PREVIEW];
  }

  updateFeatureFlag(feature: FeatureFlags, isEnabled: boolean): void {
    if (feature === FeatureFlags.PREVIEW) {
      this.featureFlagState[FeatureFlags.PREVIEW] = isEnabled;
    }
    this.saveFeatureFlags();
    location.reload(); // Reload the page to apply changes
  }

  isFeatureEnabled(feature: FeatureFlags): boolean {
    return this.featureFlagState[feature] || false;
  }
  
  private saveFeatureFlags(): void {
    localStorage.setItem('featureFlags', JSON.stringify(this.featureFlagState));
  }
}
